import React from "react";

function FilterBar({ filters, setCategoryFilter }) {
  return (
    <div className="filter-bar mb-4">
      <div className="row align-items-center">
        <div className="col-md-3 mb-2">
          <select
            className="filter-select"
            onChange={(e) => {
              setCategoryFilter({ ...filters, category: e.target.value });
            }}
          >
            <option value={""}>All Categories</option>
            <option value="Gold">Gold</option>
            <option value="Silver">Silver</option>
            <option value="Others">Others</option>
          </select>
        </div>
        <div className="col-md-3 mb-2">
          <div className="search-input-group">
            <input
              type="text"
              placeholder="Search Product"
              className="filter-input"
              onChange={(e) => {
                setCategoryFilter({ ...filters, name: e.target.value });
              }}
            />
            <i className="fas fa-search" />
          </div>
        </div>
        <div className="col-md-2 mb-2">
          <input type="date" className="filter-input" />
        </div>
        <div className="col-md-2 mb-2">
          <input type="date" className="filter-input" />
        </div>
        <div className="col-md-1 mb-2">
          <button className="btn-apply">Apply</button>
        </div>
        <div className="col-md-1 mb-2">
          <button
            className="btn-clear-inventory"
            onClick={() => {
              setCategoryFilter({ name: "", category: "" });
            }}
          >
            Clear
          </button>
        </div>
      </div>
    </div>
  );
}

export default FilterBar;
